import { AfterViewChecked, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@ngneat/transloco';
import { SignalRService } from '../../data-access-layer/services/signalr';
import { UserSessionStorageService } from '../../data-access-layer/services/user-sessions.service';
import { MessageModel } from '../../data-access-layer/interfaces/chat.interface';
import { LoadingService } from '../../data-access-layer/services/loading.service';
import { LoadingChatComponent } from './loading_chat.component';
import { CloseOnEscapeDirective } from '../../shared/directives/close-on-escape.directive';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-chat',
  standalone: true,
  imports: [CommonModule, TranslocoModule, LoadingChatComponent, CloseOnEscapeDirective, FormsModule],
  templateUrl: '../templates/chat.component.html',
  styleUrls: ['../templates/styles/chat.component.css']
})
export class ChatComponent implements OnInit, AfterViewChecked {
  isLoading: boolean = false;

  @Input() isVisible = true;
  @Input() datasourceType = "";
  @Output() isVisibleChange = new EventEmitter<boolean>();
  @ViewChild('chatBody') private chatBody!: ElementRef;

  public historyMessages: MessageModel[] = [{
    token: "",
    content: "Добро пожаловать! <br/>Если у Вас возникли вопросы или Вы хотите узнать больше, просто напишите в чат. Я всегда готов помочь!",
    role: "assistant",
    time: new Date(),
    dataSourceId: 0
  }];
  message: string = '';

  private needsScroll = false;
  private prevMessageCount = 1;
  private prevLoading = false;

  constructor(private signalRService: SignalRService, private sessionService: UserSessionStorageService) {
    this.signalRService.sending.subscribe(v => {
      if (v !== this.prevLoading) {
        this.prevLoading = v;
        this.needsScroll = true;
      }
      this.isLoading = v;
    });
  }

  ngOnInit(): void {
    let token = this.sessionService.getItem("access_token");
    this.signalRService.getAllMessages(token).subscribe((response) => {
      this.historyMessages = response;
      this.needsScroll = true;
    });
  }

  toggleVisible() {
    this.isVisible = !this.isVisible;
    this.isVisibleChange.emit(this.isVisible);
    if (this.isVisible) {
      this.needsScroll = true;
    }
  }

  async sendMessage(event?: any) {
    if (event) {
      if (event.shiftKey) {
        return;
      }
      event.preventDefault();
    }

    const text = (this.message ?? '').trim();

    if (text) {
      this.message = '';

      let token = this.sessionService.getItem("access_token");
      let currentDatasourceStr = this.sessionService.getItem("currentDataSource");
      let currentDatasourceId = (currentDatasourceStr === null) ? 0 : currentDatasourceStr.id;
      let datasourceType = this.sessionService.getItem('isBI') ? 'report' : 'dwh';
      let currentDatasource = currentDatasourceId ? Number(currentDatasourceId) : 0;

      let userMessage = {
        token: token,
        content: text,
        role: "user",
        datasourceType: datasourceType,
        time: new Date(),
        dataSourceId: currentDatasource
      }

      this.historyMessages?.push(userMessage);
      this.needsScroll = true;

      await this.signalRService.connect(token);

      await this.signalRService.sendMessage(currentDatasource, datasourceType, text);

      this.historyMessages?.push(this.signalRService.recievedMessage);
      this.needsScroll = true;
    }
  }

  ngAfterViewChecked() {
    const count = this.historyMessages?.length ?? 0;
    if (count !== this.prevMessageCount) {
      this.prevMessageCount = count;
      this.needsScroll = true;
    }

    if (this.needsScroll) {
      this.needsScroll = false;
      this.scrollToBottom();
    }
  }

  private scrollToBottom(): void {
    try {
      const el = this.chatBody.nativeElement;
      setTimeout(() => { el.scrollTop = el.scrollHeight; });
    } catch { }
  }

}
